import React from 'react';
import { useThemeClasses } from '../../lib/themes/utils';

interface CheckboxProps {
    label: string;
    path: string;
    checked: boolean;
    onChange: (path: string, checked: boolean) => void;
    className?: string;
    disabled?: boolean;
}

const Checkbox: React.FC<CheckboxProps> = ({label, path, checked, onChange, className, disabled = false}) => {
    const theme = useThemeClasses();
    
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!disabled) {
            onChange(path, e.target.checked);
        }
    };

    return (
        <label className={`
            group
            flex items-center space-x-3 
            ${theme.text.neutral}
            ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer hover:' + theme.text.neutralDark} 
            transition-colors ${theme.animations.duration}
            ${className || ''}
        `}>
            <div className="relative">
                <input 
                    type="checkbox" 
                    checked={!!checked} 
                    onChange={handleChange} 
                    className={`
                        h-5 w-5 
                        appearance-none
                        border-2 ${theme.borders.primary}
                        ${theme.radius.small}
                        checked:bg-gradient-to-r checked:from-primary-600 checked:to-secondary-600
                        checked:border-transparent
                        focus:outline-none focus:ring-2 focus:ring-primary-400 focus:ring-offset-2
                        transition-all ${theme.animations.duration}
                        ${!disabled && 'group-hover:border-primary-400'}
                    `}
                    disabled={disabled} 
                />
                {checked && (
                    <svg 
                        className="absolute inset-0 w-5 h-5 text-white pointer-events-none p-0.5" 
                        viewBox="0 0 20 20" 
                        fill="currentColor"
                    >
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                )}
            </div>
            <span className={theme.typography.body}>{label}</span>
        </label>
    );
};
export default Checkbox;
